/**
 * Node-type table for the pathfinder (vanilla WalkNodeEvaluator's PathType):
 * every block id maps to a cell kind, and a few derived heights, built once.
 */

import {
  BLOCKS, CACTUS_ID, COBWEB_ID, COLLISION_BOXES, DOOR_STATE, FIRE_ID, IS_LAVA, IS_WATERY,
  MAGMA_ID, SOUL_FIRE_ID, SWEET_BERRY_BUSH_ID,
} from '../../blocks';

/** Cell kinds. */
export const K_OPEN = 0;
export const K_BLOCKED = 1;
export const K_WATER = 2;
export const K_LAVA = 3;
export const K_FIRE = 4;
export const K_CACTUS = 5;
export const K_WEB = 6;
export const K_DOOR_CLOSED = 7;
export const K_DOOR_OPEN = 8;
/** Taller than a block (fences, walls): never walkable, never a floor. */
export const K_FENCE = 9;

/** Kind per block id. */
export const KIND = new Uint8Array(BLOCKS.length);
/** Highest collision face per block id, in blocks (0 = nothing to stand on). */
export const TOP = new Float32Array(BLOCKS.length);
/** Magma and other floors that hurt to stand on. */
export const HOT_FLOOR = new Uint8Array(BLOCKS.length);

for (let id = 0; id < BLOCKS.length; id++) {
  if (!BLOCKS[id]) continue;
  const boxes = COLLISION_BOXES[id];
  let top = 0;
  if (boxes) for (let k = 4; k < boxes.length; k += 6) top = Math.max(top, boxes[k] / 16);
  else if (BLOCKS[id].solid) top = 1;
  TOP[id] = top;
  const door = DOOR_STATE[id];
  if (IS_LAVA[id] === 1) KIND[id] = K_LAVA;
  else if (IS_WATERY[id] === 1) KIND[id] = K_WATER;
  else if (id === FIRE_ID || id === SOUL_FIRE_ID) KIND[id] = K_FIRE;
  else if (id === CACTUS_ID || id === SWEET_BERRY_BUSH_ID) KIND[id] = K_CACTUS;
  else if (id === COBWEB_ID) KIND[id] = K_WEB;
  else if (door) KIND[id] = door.open ? K_DOOR_OPEN : K_DOOR_CLOSED;
  else if (top > 1.001) KIND[id] = K_FENCE;
  else if (top > 0.5) KIND[id] = K_BLOCKED;
  else KIND[id] = K_OPEN;
}
HOT_FLOOR[MAGMA_ID] = 1;
